<!-- Contenido del formulario -->
<!-- Formulario -->
<form (submit)="enviarFormulario($event)" class="space-y-6">
  <div class="space-y-6">
    <!-- Campo: Nombre -->
    <div>
      <label for="nombre" class="block text-sm font-semibold text-slate-700 mb-2">
        Nombre de la Mesa
        <span class="text-red-500">*</span>
      </label>
      <input
        id="nombre"
        type="text"
        [formField]="$any(formulario.nombre)"
        placeholder="Ej: Mesa Principal, Terraza A"
        class="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition placeholder-slate-400 text-slate-900"
        [class.p-invalid]="formulario.nombre().invalid() && formulario.nombre().touched()"
      />
      @if (formulario.nombre().invalid() && formulario.nombre().touched()) {
        <p class="mt-1 text-sm text-red-500 font-medium">El nombre es requerido</p>
      }
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-1 gap-6">
      <!-- Campo: Número -->
      <!-- <div>
        <label for="numero" class="block text-sm font-semibold text-slate-700 mb-2">
          Número de Mesa
          <span class="text-slate-400 text-xs font-normal">(opcional)</span>
        </label>
        <app-input-number
          inputId="numero"
          [min]="0"
          placeholder="0, 1, 2..."
          class="w-full"
          [invalid]="formulario.numero().invalid() && formulario.numero().touched()"
          [value]="formulario.numero().controlValue()"
          (valueChange)="formulario.numero().value.set($event ?? 0)"
        />
        @if (formulario.numero().invalid() && formulario.numero().touched()) {
          <p class="mt-1 text-sm text-red-500 font-medium">El número debe ser positivo</p>
        }
        <p class="mt-1 text-xs text-slate-500">Número único para identificar la mesa</p>
      </div> -->

      <!-- Campo: Capacidad -->
      <div>
        <label for="capacidad" class="block text-sm font-semibold text-slate-700 mb-2">
          Capacidad (Personas)
          <span class="text-slate-400 text-xs font-normal">(opcional)</span>
        </label>
        <app-input-number
          inputId="capacidad"
          placeholder="Ej.: 4, 6, 8"
          class="w-full"
          [formField]="$any(formulario.capacidad)"
        />
        <p class="mt-1 text-xs text-slate-500">Número máximo de clientes en esta mesa</p>
      </div>
    </div>
    <!-- Vista previa de datos -->
  </div>
  @if (formulario().valid()) {
    <div class="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <p class="text-xs font-semibold text-slate-600 uppercase mb-3">Vista Previa</p>
      <div class="space-y-2 text-sm">
        <div class="flex justify-between">
          <span class="text-slate-600">Nombre:</span>
          <span class="font-semibold text-slate-900">{{ formulario.nombre().value() }}</span>
        </div>
        <!-- @if (formulario.numero()) {
          <div class="flex justify-between">
            <span class="text-slate-600">Número:</span>
            <span class="font-semibold text-slate-900">#{{ formulario.numero().value() }}</span>
          </div>
        } -->
        @if (formulario.capacidad()) {
          <div class="flex justify-between">
            <span class="text-slate-600">Capacidad:</span>
            <span class="font-semibold text-slate-900"
              >{{ formulario.capacidad().value() }} personas</span
            >
          </div>
        }
      </div>
    </div>
  }

  <!-- Botones de acción -->
  <div class="flex gap-3 pt-4">
    <button
      type="submit"
      [disabled]="formulario().invalid()"
      class="flex-1 bg-linear-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-slate-400 disabled:to-slate-400 text-white font-bold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed flex items-center justify-center gap-2"
    >
      <span>{{ mesaEditar() ? '✓ Actualizar Mesa' : '✓ Crear Mesa' }}</span>
    </button>
    @if (mesaEditar() !== undefined) {
      <button
        type="button"
        (click)="limpiarFormulario()"
        class="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-900 font-bold py-3 px-6 rounded-lg transition-all duration-200"
      >
        Limpiar
      </button>
    }
  </div>
</form>

<!-- Información adicional -->
<div class="mt-6 pt-6 border-t border-slate-200">
  <p class="text-xs text-slate-500 text-center">
    💡 Los campos marcados con <span class="text-red-500 font-bold">*</span> son obligatorios
  </p>
</div>

<!-- Footer informativo -->
<div class="mt-4 text-center text-sm text-slate-500">
  <p>¿Necesitas ayuda? Contacta con administración</p>
</div>
